module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('v-sidebar', {
    attrs: {
      "activeNavItem": "dashboard"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "main-panel"
  }, [_c('v-navbar', {
    attrs: {
      "title": 'Dashboard',
      "path": '/dashboard'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('grid-layout', {
    attrs: {
      "layout": _vm.layout,
      "col-num": 12,
      "row-height": 10,
      "is-draggable": false,
      "is-resizable": false,
      "is-mirrored": false,
      "responsive": true,
      "vertical-compact": false,
      "preventCollision": true,
      "margin": [10, 5],
      "use-css-transforms": true
    },
    on: {
      "update:layout": function($event) {
        _vm.layout = $event
      }
    }
  }, _vm._l((_vm.layout), function(item) {
    return _c('grid-item', {
      key: item.i,
      attrs: {
        "x": item.x,
        "y": item.y,
        "w": item.w,
        "h": item.h,
        "i": item.i
      }
    }, [_c('div', {
      staticClass: "card"
    }, [_c('div', {
      staticClass: "card-header"
    }, [_c('h5', {
      staticClass: "card-title"
    }, [_vm._v(_vm._s(item.i))])]), _vm._v(" "), _c('div', {
      staticClass: "card-body",
      style: ({
        overflow: 'auto',
        maxHeight: ((item.h * 10) + 50) + 'px'
      })
    }, [_c(item.c, {
      tag: "component"
    })], 1)])])
  }), 1)], 1)])])]), _vm._v(" "), _c('v-footer')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-69194d0d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/dashboard/DashboardView.vue
// module id = 725
// module chunks = 0